import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import axios from '../AxiosInstance';

import Dropzone from './dropzone';
import { Button } from '@mui/material';

export default function Gallery({ cols }) {
  const [dragId, setDragId] = React.useState();
  const [images, setImages] = React.useState([
    { id: 1, file: null, order: 1 },
    { id: 2, file: null, order: 2 },
    { id: 3, file: null, order: 3 },
    { id: 4, file: null, order: 4 },
  ]);

  const dropwidth = 70;

  const handleDrag = (event) => {
    setDragId(event.currentTarget.id);
    // console.log(dragId);
  };

  const handleDrop = (event) => {
    const dragImage = images.find((image) => image.id == dragId);
    const dropImage = images.find((image) => image.id == event.currentTarget.id);

    // console.log(dragImage);
    // console.log(dropImage);
    if (!dragImage || !dropImage) {
      // console.log('return');
      return;
    }
    const dragImageOrder = dragImage.order;
    const dropImageOrder = dropImage.order;

    const newImageState = images.map((image) => {
      if (image.id == dragId) {
        image.order = dropImageOrder;
      }
      if (image.id == event.currentTarget.id) {
        image.order = dragImageOrder;
      }
      return image;
    });
    // console.log(newImageState);

    setImages(newImageState);
  };

  const handleAddImage = (imageFile, id) => {
    // console.log(id);
    // console.log(imageFile);
    const newImageState = [...images];
    newImageState[newImageState.findIndex((el) => el.id === id)].file = imageFile;

    setImages(newImageState);
  };

  const removeImage = (id) => {
    const newImageState = [...images];
    newImageState[newImageState.findIndex((el) => el.id === id)].file = null;

    setImages(newImageState);
  };

  const upload = async () => {
    let formData = new FormData();
    images.forEach((file) => {
      // console.log(file.file);
      if (file.file) {
        formData.append('uploadImages', file.file);
      }
    });
    // console.log(formData);
    try {
      const response = await axios.post('/masters/testupload', formData);
      console.log(response);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <ImageList cols={cols}>
        {images
          .sort((a, b) => a.order - b.order)
          .map((image) => (
            <ImageListItem key={image.id}>
              <Dropzone
                width={dropwidth}
                file={image.file}
                imageId={image.id}
                handleDrag={handleDrag}
                handleDrop={handleDrop}
                onFileDropSuccess={handleAddImage}
                onRemoveFile={removeImage}
              />
            </ImageListItem>
          ))}
      </ImageList>
      <Button onClick={upload}>Upload</Button>
    </>
  );
}
